<script setup>
import RetryFailedRequest from '@/components/widgets/RetryFailedRequest.vue';
import CircularLoader from '@/components/widgets/CircularLoader.vue';

defineProps(['showRetryButton', 'loading']);
const emits = defineEmits(['retry']);
</script>

<template>
    <v-card-text>
        <RetryFailedRequest
            v-if="showRetryButton"
            @retry="emits('retry')"
        ></RetryFailedRequest>

        <CircularLoader v-else-if="loading"></CircularLoader>

        <div v-else>{{ $t('No available data') }}</div>
    </v-card-text>
</template>
